class exports.DeleteDialog extends DialogHandler

    init: () ->
        @layoutUrl = null
        @layoutSource = $('.delete-dialog')
        @classes = 'small_dialog'
        #@submitBindings = false
        @deleteTitle    ?= ''
        @deleteMessage  ?= 'this item'
        @buttonText ?= ''
        @deleteExtraMessage ?= ''
        @savingText ?= ''
        @savedText ?= ''
        @deleteItemID   ?= null
        @override_title ?= false
        @override_message ?= false
        @override_btnText ?= false
        @override_savingText ?= false

        @createDialog()

    afterLoadLayout: (selector) ->
        if(@override_title)
            selector.find('.delete-title').html @deleteTitle
        else
            selector.find('.delete-title').html 'Delete ' + @deleteTitle

        if(@override_message)
            selector.find('.delete-message').html @deleteMessage
        else
            selector.find('.delete-message').html 'Are you sure you want to delete ' + @deleteMessage

        if(@override_btnText)
            selector.find('.save-btn').html @buttonText

        if(@override_savingText)
            @savingBtnMsg = @savingText
            @savedBtnMsg = @savedText


        selector.find('.delete-item-id').val @deleteItemID
        selector.find('.delete-extra-message').html @deleteExtraMessage
        @openDialog()

        ths = this

        @submitAction = () =>
            @save('Deleting...')
